import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Select } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import SelectProvince from '../../../common/SelectProvince';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import { generateOptions } from '../../../shared/selectFn';
import { DisplayType } from '../../constants/common';

const { Option } = Select;
const displayTypeOption = generateOptions(DisplayType);

class ChartFilter extends Component {
    static contextTypes = {
        activeKey: PropTypes.string,
        business: PropTypes.array,
        contractType: PropTypes.array,
        systemDate: PropTypes.object,
        area: PropTypes.object,
    }

    handleChange = (value, key) => {
        const { params, onChange } = this.props;
        switch (key) {
            case 'contractTypeId': {
                if ((value || []).length === 0) {
                    return;
                }
                params.contractTypeId = (value || []).length ? value.join(',') : '';
                break;
            }
            case 'disease' :{
                const { value: id, text: name } = value;
                params[`${key}Id`] = id;
                params[`${key}Name`] = name;
                break;
            }
            case 'province': {
                const areaParams = {};
                const areaList = [];
                const hasCheckedArea = [];
                value.forEach(item => {
                    const { key, props: { title } = {} } = item || {};
                    areaParams[`params[${title}]`] = key;
                    areaList.push(title);
                    hasCheckedArea.push(key);
                });
                params.areaParams = areaParams;
                params.hasCheckedArea = hasCheckedArea;
                params.areaName = areaList.join(',');
                break;
            }
            case 'investigationAreaId' :{
                params[key] = value;
                if(!value) {
                    params.diseaseName = undefined;
                    params.diseaseId = undefined;
                }
                break;
            }
            default:
                params[key] = value;
                break;
        }
        onChange(params);
    }

    render() {
        const { activeKey, business, contractType, systemDate: { trueYear }, area } = this.context;
        const { params, onSearch, onExport } = this.props;
        const businessOption = business
            .filter(i => i.groupId !== 2)
            .map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const statisticsDateOption = [];
        for (let start = 2016, end = trueYear || 2016; start <= end; start++) {
            statisticsDateOption.push(<Option key={start}>{start}</Option>);
        }
        const areaOption = area.map(i => <Option key={i.investigationAreaId}>{i.investigationAreaName}</Option>);
        return (
            <div className="filter-wrap" style={{ marginBottom: 10, padding: 10, paddingBottom: 0, background: '#fff' }}>
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">业务线</label>
                    <Select
                        placeholder="请选择"
                        value={format('toString', params.lineOfBusiness)}
                        style={{ width: 80, verticalAlign: 'middle' }}
                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">统计形式</label>
                    <Select
                        placeholder="请选择"
                        value={format('toString', params.displayType)}
                        style={{ width: 140, verticalAlign: 'middle' }}
                        onChange={value => this.handleChange(value, 'displayType')}
                    >
                        {displayTypeOption}
                    </Select>
                </div>
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">项目领域</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{ width: 120 }}
                        value={params.investigationAreaId}
                        onChange={value => this.handleChange(value, 'investigationAreaId')}
                    >
                        {areaOption}
                    </Select>
                </div>
                <div className="filter-item">
                    <label className="filter-label">疾病</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 100 }}
                        params={{ investigationAreaId: params.investigationAreaId , limit: 20}}
                        placeholder="输入名称检索"
                        url={API_URL.common.queryAllDisease}
                        value={params.diseaseName}
                        disabled={!params.investigationAreaId }
                        config={{ id: 'diseaseId', name: 'diseaseName' }}
                        onChange={(option) => this.handleChange(option, 'disease')}
                    />
                </div>
                <div className="filter-item">
                    <label className="filter-label">区域/城市</label>
                    <SelectProvince
                        placeholder={'请选择'}
                        areaName={params.areaName || ''}
                        saveProvince={value => this.handleChange(value, 'province')}
                        hasCheckedArea={params.hasCheckedArea || []}
                        style={{verticalAlign: 'middle', width:'100px'}}
                    />
                </div>
                <div className="filter-item">
                    <label className="filter-label">统计时间</label>
                    <Select
                        placeholder="请选择"
                        value={format('toString', params.year)}
                        style={{ width: 80, verticalAlign: 'middle' }}
                        onChange={value => this.handleChange(value, 'year')}
                    >
                        {statisticsDateOption}
                    </Select>
                </div>
                <div className="filter-item">
                    <Button type="primary" onClick={onSearch}>统计</Button>
                    <Button className="btn-yellow" style={{ marginLeft: 10 }} onClick={onExport}>明细导出</Button>
                </div>
            </div>
        );
    }
}

export default ChartFilter;



// WEBPACK FOOTER //
// ./src/components/homePage/personIndicatorAnalysis/components/ChartFilter.js